export interface IBreadcrumbItem {
  label: string;
  url: string;
}

export interface IBreadcrumbSupport {
  createBreadcrumbs(): IBreadcrumbItem[];
}


export class BreadcrumbSupport implements IBreadcrumbSupport {
     createBreadcrumbs() {
         return [];
     }
}
